import * as tslib_1 from "tslib";
import { FormField } from '../form_field';
var EditableField = /** @class */ (function (_super) {
    tslib_1.__extends(EditableField, _super);
    function EditableField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'readonly,require,disable';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    EditableField.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "EditableField",
            "readonly": this.readonly,
            "require": this.require,
            "disable": this.disable
        });
    };
    EditableField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return EditableField;
}(FormField));
export { EditableField };
//# sourceMappingURL=editable_field.js.map